import { useEffect, useState } from "react";
import GridComponentNew from '../shared/grid';
import setToast from '../../helpers/toaster.helper';
import EditChannelComponent from "./edit-channel.component";
import ConfirmDialog from "../shared/confirm-dialog.component";
import PageHeaderComponentNew from "../shared/page-header.component";
import { LoadChannels } from '../../actions';
import { AppRoutes } from '../routes/route.path';
import { ChannelPlanModel, ChannelPlanStatus, ChannelUserModel, mapToChannelUser } from '../../models/users.model';
import { ToasterType } from '../shared/toaster/toaster.model';
import { dateComparator } from "../shared/grid/grid.services";
import { AvatarRenderer } from '../shared/grid/avatarRenderer';
import { StatusRenderer } from '../shared/grid/statusRenderer';
import { UtilityService } from "../../services/UtilityService";
import { ActionsRenderer } from '../shared/grid/actionsRenderer';
import { ChannelService } from '../../services/channels/ChannelAcountService';
import { setHeaderCount, setHeaderTitle, setRefreshHandler } from "../../helpers/header.helper";
import { ChannelAccountModel, ChannelAccountStatus, ChannelType } from '../../models/channels/channels.model';
import { OrganizationDetails } from '../../models/organization.model';
import { ColDef, ICellRendererParams, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community'
import { AddChannelicon, EditIcon, DisconnectBtnIcon, ConnectBtnIcon, ReauthorizeIcon, TrashIcon, ViewPageIcon, CancelIcon, CopyIcon, ShareChatLinkIcon, ChannelsGridEmptyIcon, LiveChatSuccesfullyConnectedIcon, FacebookActiveIcon, InstaActiveIcon, WhatsappActiveIcon, FacebookGreyIcon, GoogleBusinessIcon, InstaGreyIcon, LivechatGreyIcon, LiveChatIcon, WhatsappGreyIcon, AllChannelsIcon } from "../../icon";
import { GridStatusLabelVariant, appNote, buttonLabels, pageTitles, ToasterTexts, ActionLabels, emptyLabels } from '../shared/constants'
import LiveChatValidate from "./live-chat-validate.component";
import { Dialog, DialogTitle, DialogContent, Tooltip } from "@mui/material";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors';
import { useLocation, useNavigate } from "react-router";
import SelectChannelSideBarComponent from "./select-channel-side-bar-component";
import { ChannelUserService } from "../../services/ChannelUserService";
import { Role } from "../../models/roles.model";
import Config from "../../config";
import { LiveChatService } from "../../services/channels/LiveChatService";
import ButtonComponent from "../shared/button/button.component";
import AnimateLoader from "../shared/loaders/animate-loader.component";
import messagsLogsLoader from "../shared/loaders/message-logs-search-inprogress-loader.json";
import { ShopifyService } from "../../services/channels/ShopifyService";
import UpgradePlanInfoComponent from "../channel-plans/upgrade-plan-info.component";
interface IProps {
}

const ChannelViewComponent = (props: IProps) => {

    const ActiveChannelsTypes: number[] = useSelector(selector.ActiveChannelsTypes)

    const initialChannelOptions = [
        { Label: "All", ChannelType: 100, hasSubOptions: false, SubOptions: [], ActiveIcon: AllChannelsIcon, Icon: AllChannelsIcon, Active: false, SubOptionsOpen: false },
        { Label: "Facebook", ChannelType: ChannelType.FACEBOOK, hasSubOptions: false, SubOptions: [], ActiveIcon: FacebookActiveIcon, Icon: FacebookActiveIcon, Active: ActiveChannelsTypes.includes(1), SubOptionsOpen: false },
        { Label: "Instagram", ChannelType: ChannelType.INSTAGRAM, hasSubOptions: false, SubOptions: [], ActiveIcon: InstaActiveIcon, Icon: InstaActiveIcon, Active: (ActiveChannelsTypes.includes(2) && !ActiveChannelsTypes.includes(1)), SubOptionsOpen: false },
        { Label: "Livechat", ChannelType: ChannelType.LIVE_CHAT, hasSubOptions: false, SubOptions: [], ActiveIcon: LiveChatIcon, Icon: LiveChatIcon, Active: (ActiveChannelsTypes.includes(4) && !ActiveChannelsTypes.includes(1) && !ActiveChannelsTypes.includes(2)), SubOptionsOpen: false },
        { Label: "Google Business Messages", ChannelType: ChannelType.GOOGLE_BUSINESS, hasSubOptions: false, SubOptions: [], ActiveIcon: GoogleBusinessIcon, Icon: GoogleBusinessIcon, Active: false, SubOptionsOpen: false },
        { Label: "Whatsapp", ChannelType: ChannelType.WHATSAPP, hasSubOptions: false, SubOptions: [], ActiveIcon: WhatsappActiveIcon, Icon: WhatsappActiveIcon, Active: (ActiveChannelsTypes.includes(3) && !ActiveChannelsTypes.includes(1) && !ActiveChannelsTypes.includes(2) && !ActiveChannelsTypes.includes(4)), SubOptionsOpen: false }
    ]

    const dispatch = useDispatch()
    const location = useLocation();

    const Channels: ChannelAccountModel[] = useSelector(selector.Channels)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsWordPress: boolean = useSelector(selector.IsWordpress)
    const IsShopify: boolean = useSelector(selector.IsShopify)
    const Shopify_Shop: string = useSelector(selector.Shopify_Shop)
    const Shopify_Access_Token: string = useSelector(selector.Shopify_Access_Token)
    const WordpressDomain: string = useSelector(selector.WordPressDomain)
    const CurrentUser: ChannelUserModel = ChannelUserService.getCurrentUserFromLocalStorage();
    const PlanDetails :ChannelPlanModel = useSelector(selector.PlanDetails)

    const navigate = useNavigate();

    const [SelectedRow, setSelectedRow] = useState<ChannelAccountModel>()
    const [buttonName, setButtonName] = useState("")
    const [text, setText] = useState("")
    const [isDeleted, setIsDeleted] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isConnect, setIsConnect] = useState<boolean>(false);
    const [gridApi, setGridApi] = useState<any>();
    const [columnApi, SetColumnApi] = useState<any>(null);
    const [validateOpen, setValidateOpen] = useState<boolean>(false);
    const [liveChatEdit, setliveChatEdit] = useState<boolean>(false);
    const [liveChatTitle, setliveChatTitle] = useState<string>("");
    const [liveChatIcon, setliveChatIcon] = useState<any>("");
    const [welcomeMessage, setwelcomeMessage] = useState<string>("");
    const [welcomeMessageStatus, setWelcomeMessageStatus] = useState<boolean>(false);
    const [channelOptions, setChannelOptions] = useState(initialChannelOptions);
    const [sidebarWidth, setSidebarWidth] = useState<number>(IsMobileDevice ? 10 : 24);
    const [rowData, setRowData] = useState<any[]>();
    const [activeChannel, setActiveChannel] = useState<any>({ Label: "", ChannelType: (IsShopify || IsWordPress) ? ChannelType.LIVE_CHAT : ChannelType.FACEBOOK, hasSubOptions: false, SubOptions: null, Icon: FacebookActiveIcon, Active: false, SubOptionsOpen: false });
    const [showConfirm, setShowConfirm] = useState<boolean>(false)
    const [shopifyScriptTag, setShopifyScriptTag] = useState<any>("")
    const [showUpgradePlan, setShowUpgradePlan] = useState<boolean>(false)

    const [org, setOrg] = useState<OrganizationDetails>({
        ID: "",
        Name: "",
        Email: "",
        ZipCode: "",
        Address: "",
        MobileNumber: "",
        Industry: "",
        HouseNumber: "",
        Reference: "",
        City: "",
        State: "",
        Country: "",
    });

    useEffect(() => {
        if (!!ActiveChannelsTypes.length && !!Channels.length && !activeChannel.Label) {
            let initialActiveChannel = (IsShopify || IsWordPress) ? initialChannelOptions.find(x => x.ChannelType === ChannelType.LIVE_CHAT) : initialChannelOptions.find(x => ActiveChannelsTypes.includes(x.ChannelType))
            setChannelOptions(initialChannelOptions.map(x => x.Label === initialActiveChannel.Label ? { Label: initialActiveChannel.Label, ChannelType: initialActiveChannel.ChannelType, hasSubOptions: false, SubOptions: [], ActiveIcon: initialActiveChannel.ActiveIcon, Icon: initialActiveChannel.Icon, Active: true, SubOptionsOpen: false } : x))
            setActiveChannel({ Label: initialActiveChannel.Label, ChannelType: initialActiveChannel.ChannelType, hasSubOptions: false, SubOptions: [], ActiveIcon: initialActiveChannel.ActiveIcon, Icon: initialActiveChannel.Icon, Active: true, SubOptionsOpen: false })
        }
    }, [Channels, ActiveChannelsTypes])

    useEffect(() => {
        setRowData(activeChannel.ChannelType === 100 ? Channels : Channels.filter(x => x.ChannelType === activeChannel.ChannelType))
    }, [activeChannel, Channels])

    useEffect(() => {
        if (!!rowData) {
            setHeaderCount(`${rowData.filter(x => x.Status !== ChannelAccountStatus.DELETED).length} channels`)
        }
    }, [rowData])

    const getShopifyScriptTag = () => {
        ShopifyService.GetAllScriptTags({ shop: Shopify_Shop, access_token: Shopify_Access_Token }).then(res => {
            setShopifyScriptTag(res.data.script_tags.find(x => x.src.includes("falkonsms-develop/live-chat/widget.js")))
        })
    }

    useEffect(() => {
        if (IsShopify && !shopifyScriptTag) {
            getShopifyScriptTag()
        }
    }, [shopifyScriptTag])

    const ChanelsColoumnDefs: ColDef[] = [
        {
            field: "Name",
            headerName: "Account",
            valueGetter: (params: ValueGetterParams) => {
                return `${params.data.Name}`
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                const AvatarComponent = {
                    component: AvatarRenderer,
                    params: {
                        SetName: params.data.NickName,
                        HideAvatar: IsMobileDevice,
                        Icon: params.data.ChannelIcon ? params.data.ChannelIcon : ""
                    }
                }
                if (params.data) {
                    return AvatarComponent
                }
                return undefined
            },
            resizable: true,
            minWidth: 200
        },
        {
            field: "Status",
            headerName: "Status",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.Status === ChannelAccountStatus.CONNECTED ? "Connected" : (params.data.Status === ChannelAccountStatus.DISCONNECTED || params.data.Status === ChannelAccountStatus.DISCONNECTED_BY_PLAN_EXPIRY) ? "Disconnected" : "Pending Validation";
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data) {
                    const label = params.data.Status === ChannelAccountStatus.CONNECTED ? "Connected" : (params.data.Status === ChannelAccountStatus.DISCONNECTED || params.data.Status === ChannelAccountStatus.DISCONNECTED_BY_PLAN_EXPIRY) ? "Disconnected" : "Pending Validation";
                    const variant = params.data.Status === ChannelAccountStatus.CONNECTED ? GridStatusLabelVariant.Active : (params.data.Status === ChannelAccountStatus.DISCONNECTED || params.data.Status === ChannelAccountStatus.DISCONNECTED_BY_PLAN_EXPIRY) ? GridStatusLabelVariant.Inactive : GridStatusLabelVariant.Warning;
                    const Status = {
                        component: StatusRenderer,
                        params: {
                            Variant: variant, Label: label, Id: params.data.ID, ClassName: "min-h-3 d-flex align-center justify-center"
                        }
                    }
                    return Status
                }
                return undefined
            },
            wrapText: IsMobileDevice ? true : false,
            autoHeight: IsMobileDevice ? true : false,
            resizable: true,
            minWidth: IsMobileDevice ? null : 200
        },
        {
            field: "UpdatedDate",
            headerName: "Last updated",
            valueFormatter: (params: ValueFormatterParams) => {
                return UtilityService.convertDateToDay(params.value).toString()
            },
            valueGetter: (params: ValueGetterParams) => {
                return UtilityService.convertDateToDay(params.data.UpdatedDate).toString()
            },
            sort: !IsMobileDevice ? 'desc' : null,
            hide: IsMobileDevice,
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.UpdatedDate, nodeB.data.UpdatedDate),

            resizable: true,
            minWidth: 200
        },
        {
            field: "Action",
            maxWidth: 40,
            headerName: "",
            pinned: "right",
            lockPinned: true,
            lockPosition: "right",
            cellClass: "ag-cell-actions-style",
            headerClass: "bg-color-secondary",
            cellRenderer: params =>
                <ActionsRenderer
                    MenuData={getMenuActions(params.data)}
                    {...params}
                />,
            resizable: false,
            sortable: false,
        },
    ]

    const getMenuActions = (data: ChannelAccountModel) => {
        return [
            {
                Name: ActionLabels.EDIT,
                Icon: EditIcon,
                OnClick: data?.ChannelType === ChannelType.LIVE_CHAT ? () => handleLiveChatEdit(data) : () => editChannel(data),
            },
            {
                Name: data.Status === ChannelAccountStatus.CONNECTED ? ActionLabels.DISCONNECT : ActionLabels.CONNECT,
                Icon: data.Status === ChannelAccountStatus.CONNECTED ? DisconnectBtnIcon : ConnectBtnIcon,
                OnClick: () => openConnectDialog(data, data?.Status === ChannelAccountStatus.CONNECTED ? ActionLabels.DISCONNECT : ActionLabels.CONNECT),
                Hide: data?.Status === ChannelAccountStatus.VALIDATION_PENDING || data?.Status === ChannelAccountStatus.VALIDATION_PENDING_BY_PLAN_EXPIRY,
            },
            {
                Name: ActionLabels.VIEWPAGE,
                Icon: ViewPageIcon,
                OnClick: () => { window.open(data.ChannelRedirectUrl, "_blank") },
                Hide: !((data?.ChannelType === ChannelType.FACEBOOK) || (data?.ChannelType === ChannelType.INSTAGRAM)),
            },
            {
                Name: ActionLabels.VALIDATE,
                Icon: ReauthorizeIcon,
                OnClick: () => handleValidate(data),
                Hide: data?.Status !== ChannelAccountStatus.VALIDATION_PENDING && data?.Status !== ChannelAccountStatus.VALIDATION_PENDING_BY_PLAN_EXPIRY,
            },
            // {
            //     Name: data.ChannelWelcomeMessageStatus === ChannelWelcomeStatusModel.ACTIVE ? ActionLabels.DISABLE_WELCOME_MESSAGE : ActionLabels.ENABLE_WELCOME_MESSAGE,
            //     Icon: EditIcon,
            //     OnClick: () => handleWelcomeMessage(data.ChannelWelcomeMessageStatus),
            //     Hide: data?.ChannelType !== ChannelType.LIVECHAT,
            //     Variant:"disabled",
            // },
            {
                Name: IsWordPress ? "Add To WordPress Website" : IsShopify ? "Add to shopify website" : ActionLabels.COPYCODE,
                Icon: CopyIcon,
                OnClick: () => { handleCopyCode(data.ID, data.Name, data.Status); },
                Hide: data?.ChannelType !== ChannelType.LIVE_CHAT || shopifyScriptTag?.src?.includes(data?.ID),
            },
            {
                Name: "Remove from shopify website",
                Icon: TrashIcon,
                OnClick: () => { handleShopifyWidgetRemoval() },
                Hide: !IsShopify || !shopifyScriptTag?.src?.includes(data?.ID),
            },
            // {
            //     Name: ActionLabels.REAUTHORIZE,
            //     Icon: ReauthorizeIcon,
            //     OnClick: () => { },
            // },
            {
                Name: ActionLabels.DELETE,
                Icon: TrashIcon,
                OnClick: () => openConfirmDialog(data),
            },
            {
                Name: ActionLabels.SHARE_CHAT_COPY_LINK,
                Icon: ShareChatLinkIcon,
                OnClick: () => copyShareChatCode(data.ID),
                Hide: (data?.ChannelType !== ChannelType.LIVE_CHAT || data?.Status === ChannelAccountStatus.VALIDATION_PENDING || data?.Status === ChannelAccountStatus.DISCONNECTED || data?.Status === ChannelAccountStatus.DISCONNECTED_BY_PLAN_EXPIRY || data?.Status === ChannelAccountStatus.VALIDATION_PENDING_BY_PLAN_EXPIRY),
            },
        ]
    }
    const user = mapToChannelUser(JSON.parse(localStorage.getItem("current-user"))) as ChannelUserModel;

    const openAddChanel = async () => {
        if (IsWordPress || IsShopify) {
            navigate(AppRoutes.ADD_CHANNELS_LIVE_CHAT)
        }
        else {
            navigate(AppRoutes.ADD_CHANNELS)
        }
    };

    const globalSearch = (e: any) => {
        gridApi.setQuickFilter(e.target.value)
    };

    const editChannel = (data?: ChannelAccountModel) => {
        setIsEdit(true);
        setSelectedRow(data);
    }

    const handleLiveChatEdit = (data?: ChannelAccountModel) => {
        navigate(AppRoutes.ADD_CHANNELS_LIVE_CHAT, { state: data })
    }

    const closeEditChannel = () => {
        setIsEdit(false);
    }

    const handleValidate = (data) => {
        if (data.Status === ChannelAccountStatus.VALIDATION_PENDING_BY_PLAN_EXPIRY || (PlanDetails.Status !== ChannelPlanStatus.ACTIVE && PlanDetails.Status !== ChannelPlanStatus.TRAIL)) {
            setShowUpgradePlan(true)
        }
        else {
            setSelectedRow(data)
            setValidateOpen(true)
        }
    }

    const handleWidgetDetailsUpdate = (title: string, welcome_message: string, icon: any, welcomeMessageStatus: boolean) => {
        setliveChatTitle(title)
        setliveChatIcon(icon)
        setWelcomeMessageStatus(welcomeMessageStatus)
    }

    const deleteConfirmDialog = (isConfim: boolean) => {
        setIsLoading(true);
        if (!!isConfim) {
            ChannelService.deleteChannelAccount(user.OrganizationID, SelectedRow?.ID)
                .then(() => {
                    setToast(ToasterTexts.CHANNEL_DELETE_SUCCESS.replace('<Name>', SelectedRow?.NickName), ToasterType.SUCCESS)
                    setIsDeleted(false);
                    setIsLoading(false)
                    setSelectedRow(undefined);
                    LoadChannels(dispatch, user.OrganizationID)
                }).catch((error: any) => {
                    setToast(ToasterTexts.SOMETHING_WENT_WRONG_MESSAGE, ToasterType.DANGER)
                    setIsDeleted(false);
                    setIsLoading(false)
                    setSelectedRow(undefined);
                })
        }
        else {
            setIsDeleted(false);
            setIsLoading(false)
            setSelectedRow(undefined);
        }
    };
    const openConnectDialog = (data: ChannelAccountModel, action: string) => {
        if (data.Status === ChannelAccountStatus.DISCONNECTED_BY_PLAN_EXPIRY || (PlanDetails.Status !== ChannelPlanStatus.ACTIVE && PlanDetails.Status !== ChannelPlanStatus.TRAIL)) {
            setShowUpgradePlan(true)
        }
        else {
            let text = data.Status === ChannelAccountStatus.CONNECTED ? appNote.DISCONNECT_CHANNEL : appNote.CONNECT_CHANNEL;
            setIsConnect(true);
            setText(text);
            setButtonName(action);
            setSelectedRow(data);
        }
    }

    const closeConnectDialog = (isdata: boolean) => {
        let status = SelectedRow?.Status;
        setIsLoading(true);
        if (!!isdata) {
            if (status === ChannelAccountStatus.CONNECTED) {
                ChannelService.disableChannelAccount(user.OrganizationID, SelectedRow?.ID, user.ID)
                    .then(() => {
                        setToast(ToasterTexts.DISCONNECT_CHANNEL.replace('<Name>', SelectedRow?.NickName), ToasterType.SUCCESS)
                        setIsConnect(false);
                        setSelectedRow(undefined);
                        LoadChannels(dispatch, user.OrganizationID)
                        setIsLoading(false);
                    }).catch((error: any) => {
                        setToast(ToasterTexts.SOMETHING_WENT_WRONG_MESSAGE, ToasterType.DANGER)
                        setIsConnect(false);
                        setSelectedRow(undefined);
                        setIsLoading(false);
                    })
            }
            else {
                ChannelService.enableChannelAccount(user.OrganizationID, SelectedRow?.ID, user.ID)
                    .then(() => {
                        setToast(ToasterTexts.CONNECT_CHANNEL.replace('<Name>', SelectedRow?.NickName), ToasterType.SUCCESS)
                        setIsConnect(false);
                        setSelectedRow(undefined);
                        setIsLoading(false);
                        LoadChannels(dispatch, user.OrganizationID)
                    }).catch((error: any) => {
                        setIsConnect(false);
                        setSelectedRow(undefined);
                        setIsLoading(false);
                    })
            }
        } else {
            setIsConnect(false);
            setSelectedRow(undefined);
            setIsLoading(false);
        }
    };

    const openConfirmDialog = (data: ChannelAccountModel) => {
        setIsDeleted(true);
        setSelectedRow(data);
    };

    const HandleRowClick = (row: ChannelAccountModel) => {
        return
    }

    const onGridReady = (params) => {
        setGridApi(params.api)
        SetColumnApi(params.columnApi)
    }

    const handleClose = (refresh?: boolean) => {
        setValidateOpen(false)
        setliveChatEdit(false)
        if (refresh) {
            LoadChannels(dispatch, user.OrganizationID)
        }
    }

    const handleCopyCode = async (channelId, channelName, channelStatus) => {
        if (IsWordPress) {
            setIsLoading(true)
            setShowConfirm(true)

            try {
                const response = await fetch(`${WordpressDomain}/wp-json/custom/v1/append-script`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        script: `<script src="${Config.WIDGET_FILE_LINK}?url=${Config.FALKON_CONNECT_APP_URL}/falkon-live-chat/${channelId}" type="text/javascript">
    </script>`,
                    }),
                });

                if (response.ok) {
                    const result = await response.json();
                    console.log('Success:', result);
                    LiveChatService.WordpressLiveChatValidation(channelId, { weburl: WordpressDomain }).then((res) => {
                        setIsLoading(false)
                    }).catch((err) => {

                    })
                } else {
                    console.error('Failed to send script:', response.statusText);
                    setIsLoading(false)
                }

            }
            catch (error) {
                console.error('Error:', error);
                alert('An error occurred');
            }

        }
        if (IsShopify) {

            const scriptSrc = `${Config.WIDGET_FILE_LINK}?url=${Config.FALKON_CONNECT_APP_URL}/falkon-live-chat/${channelId}`;
            if (shopifyScriptTag?.id) {
                handleShopifyWidgetRemoval()
            }

            ShopifyService.AddLiveChatScript({ shop: Shopify_Shop, script: scriptSrc, access_token: Shopify_Access_Token }).then((res) => {
                if (res.status === 200) {
                    if (channelStatus === ChannelAccountStatus.VALIDATION_PENDING || channelStatus === ChannelAccountStatus.VALIDATION_PENDING_BY_PLAN_EXPIRY) {
                        LiveChatService.WordpressLiveChatValidation(channelId, { weburl: Shopify_Shop }).then((res) => {
                            setIsLoading(false)
                            setToast(`${channelName} widget added successfully to shopify website`, ToasterType.SUCCESS)
                            getShopifyScriptTag()
                        })
                    }
                    else {
                        setIsLoading(false)
                        setToast(`${channelName} widget added successfully to shopify website`, ToasterType.SUCCESS)
                        getShopifyScriptTag()
                    }
                }
            }
            ).catch(() => {
                setIsLoading(false)
                setToast(`cannot add ${channelName} widget to shopify website`, ToasterType.DANGER)
            })

        }
        else {
            const text = `
       <script src="${Config.WIDGET_FILE_LINK}?url=${Config.FALKON_CONNECT_APP_URL}/falkon-live-chat/${channelId}" type="text/javascript">
    </script>`
            navigator.clipboard.writeText(text);
            setToast("Copied to clipboard Sucessfully!", ToasterType.SUCCESS, "default")
        }
    }

    const handleShopifyWidgetRemoval = () => {
        ShopifyService.DeleteLiveChatScript({ shop: Shopify_Shop, access_token: Shopify_Access_Token }, shopifyScriptTag.id).
            then((res) => {
                setToast("successfully removed widget from shopify website", ToasterType.SUCCESS)
                setShopifyScriptTag("")
            }).
            catch(() => {
                setToast("removing widget failed", ToasterType.DANGER)
            })
    }

    useEffect(() => {
        setHeaderTitle(pageTitles.CHANNELS);
        if (!Channels || Channels.length === 0) {
            LoadChannels(dispatch, user.OrganizationID)
        }
        setHeaderCount(`0 channels`)
        setRefreshHandler(gridRefresh);
    }, []);

    const gridRefresh = () => {
        LoadChannels(dispatch, user.OrganizationID);
        if (!!columnApi) {
            columnApi.resetColumnState()
        }
        if (!!gridApi) {
            gridApi.refreshCells({ force: true })
            gridApi.deselectAll();
        }
    }

    const copyShareChatCode = (id) => {
        navigator.clipboard.writeText(`${window.location.origin}/${id}/share-to-chat-link`);
        setToast("Copied to clipboard Sucessfully!", ToasterType.SUCCESS, "default")
    }

    const handleChannelOptions = (ChannelOptions) => {
        let ActiveChannel = ChannelOptions.find(x => x.Active === true)
        setChannelOptions(ChannelOptions)
        setActiveChannel(ActiveChannel)
    }

    const handleSideBarWidth = (number) => {
        setSidebarWidth(number)
    }

    return (
        <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
            <div className='w-p-96 mx-auto'>
                <PageHeaderComponentNew
                    Actions={CurrentUser?.RoleID === Role.ORGANIZATION_ADMIN ?
                        [
                            {
                                OnClick: () => openAddChanel(),
                                ButtonLabel: buttonLabels.ADD_CHANNEL,
                                Icon: AddChannelicon,
                                ClassName: "mr-2",
                                Variant: "primary-btn",
                            }
                        ] : null
                    }
                    onSearch={globalSearch}
                    PlaceHolder={"Find a Channel..."}
                />
            </div>
            <div className={`w-p-100 h-p-100 d-flex justify-center align-center  ${IsMobileDevice ? "" : "bg-color-secondary"}`}>
                <div className={`w-p-96 h-p-100 bg-color-side-bar br-3 d-flex o-hidden ${IsWordPress ? "h-p-85" : ""}`}>
                    {!IsWordPress && !IsShopify &&
                        <div className={`min-w-${sidebarWidth} d-flex align-center justify-center h-p-96 my-auto ml-2 select-channel-active-border br-2`}>
                            <SelectChannelSideBarComponent Options={channelOptions} handleSidebarWidth={handleSideBarWidth} handleOptions={handleChannelOptions} HideAddChannelButton={true} />
                        </div>
                    }
                    <div className={`${(IsWordPress || IsShopify) ? "w-p-100 h-v-85 " : `${IsMobileDevice ? "w-p-100" : `flex-1`}  h-p-100 channel-side-bar-icon`}`}>
                        <GridComponentNew
                            ColumnDefs={ChanelsColoumnDefs}
                            IsPaginationEnabled={true}
                            OnGridReady={onGridReady}
                            RowData={rowData?.filter(x => x.Status !== ChannelAccountStatus.DELETED)}
                            OnGridRowClick={HandleRowClick}
                            EmptyLabel={<div>
                                <div className="mt-8"><ChannelsGridEmptyIcon /></div>
                                <span className="h5-medium">{emptyLabels.CHANNELS}</span>
                            </div>}
                            LockVisible={IsMobileDevice}
                        />
                    </div>
                </div>
            </div>
            {
                isEdit && (
                    <EditChannelComponent
                        Show={isEdit}
                        Channel={SelectedRow}
                        CloseEditChannel={closeEditChannel}
                    />
                )
            }
            {
                isConnect && (
                    <ConfirmDialog
                        ButtonName={buttonName}
                        onClose={closeConnectDialog}
                        Show={isConnect}
                        Text={text}
                        Loading={isLoading}
                    />
                )
            }
            {
                <ConfirmDialog
                    ButtonName={buttonLabels.DELETE}
                    onClose={deleteConfirmDialog}
                    Show={isDeleted}
                    Text={appNote.CHANNEL_DELETE}
                    Loading={isLoading}
                />
            }
            {validateOpen && <Dialog
                open={true}
                BackdropProps={{ style: { backgroundColor: "transparent" } }} classes={{ paper: "w-90 br-2  dialogue-shadow" }}
            >
                <DialogTitle id="alert-dialog-title">
                    <div className="h2-semibold color-text-field-font d-flex">
                        Validate Live Chat
                        <Tooltip title='Close' placement='bottom'>
                            <span className={"ml-auto"}>
                                <CancelIcon className={"c-pointer"} onClick={() => handleClose()} />
                            </span>
                        </Tooltip>
                    </div>
                </DialogTitle>
                <DialogContent className={` w-p-92 h-50 pb-0`}>
                    <LiveChatValidate ChannelId={SelectedRow.ID} WidgetTitle={SelectedRow.Name} Hide={validateOpen} handleClose={handleClose} />
                </DialogContent>
            </Dialog>
            }

            {
                showConfirm &&
                < Dialog
                    maxWidth='md'
                    open={showConfirm}
                    onClose={() => { setShowConfirm(false) }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    BackdropProps={{ style: { backgroundColor: "transparent" } }} classes={{ paper: "w-75 h-60 br-2  dialogue-shadow" }}
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className="h2-semibold color-text-field-font d-flex">
                            <Tooltip title='Close' placement='bottom'>
                                <span className={"ml-auto"}>
                                    <CancelIcon className={"c-pointer"} onClick={() => { setShowConfirm(false) }} />
                                </span>
                            </Tooltip>
                        </div>
                    </DialogTitle>
                    <DialogContent className={` w-p-91 pb-0`}>
                        {isLoading ?
                            <div className='d-flex flex-direction justify-center align-center bg-color-secondary my-auto h-v-50 mx-2 o-x-hidden'>
                                <AnimateLoader LoaderAnimation={messagsLogsLoader} className='w-25' />
                                <div className="color-primary-accent h1-medium">
                                    Falkon Chat Adding to Website
                                </div>
                            </div>
                            :
                            <div className={` paper-background m-auto br-2 d-flex flex-direction `}>
                                <div className={` d-flex justify-center align-center`}>
                                    <LiveChatSuccesfullyConnectedIcon />
                                </div>
                                <div className="h-p-20 t-align-center d-flex justify-center align-center color-secondary-success h2-semibold">
                                    Live Chat Successfully Added!
                                </div>
                                <div className="h-p-20 d-flex justify-center align-center">
                                    <ButtonComponent ButtonLabel={"Go To Wordpress Website"} Variant={"primary-btn"} ClassName="" OnClick={() => { window.open(WordpressDomain, '_blank'); setShowConfirm(false); LoadChannels(dispatch, user.OrganizationID) }} />
                                </div>
                            </div>
                        }
                    </DialogContent>
                </Dialog >
            }
            {
                showUpgradePlan && <UpgradePlanInfoComponent show={showUpgradePlan} close={() => { setShowUpgradePlan(false) }} AcessingFeatures={[{ featureName: "Subscription Required", Desc: "Subscribe to a plan to unlock all features" }]} />
            }
        </div>
    )
}

export default ChannelViewComponent;